export namespace OrganizationExport {
    /** Extend this union when adding a new export object type. */
    export type Kind = "budget";

    export type Mode = "singleOrg" | "bulkByFiscalYear" | "bulkByOrgIds";

    /** Entry points pass the same shape; mode selects which fetch path runs on confirm. */
    export type Context = {
        mode: Mode;
        organizationId?: number;
        organizationIds?: number[];
        fiscalYear?: string;
        fiscalYearId?: number;
        organizationName?: string;
    };

    export type BudgetOptions = {
        includeOrgBudgetSummary: boolean;
        includeBudgetPlans: boolean;
        includeLineItems: boolean;
    };

    export const DEFAULT_BUDGET_OPTIONS: BudgetOptions = {
        includeOrgBudgetSummary: true,
        includeBudgetPlans: true,
        includeLineItems: true,
    };

    export type Selection = {
        kinds: Kind[];
        budget?: BudgetOptions;
        /** Set when budget export is selected; scopes org and bulk org-id exports. */
        fiscalYearId?: number;
        fiscalYear?: string;
    };

    export type KindDefinition = {
        kind: Kind;
        label: string;
        description: string;
        /** When false, kind is listed as future work and cannot be selected. */
        implemented: boolean;
    };

    /**
     * Registry of organization export object types. Add a row here and a handler in
     * {@link organization.export.budget.handler#ORGANIZATION_EXPORT_HANDLERS} when wiring a new kind (e.g. memberships, events).
     */
    export const KIND_REGISTRY: readonly KindDefinition[] = [
        {
            kind: "budget",
            label: "Budget",
            description: "Organization budgets, plans, and line items",
            implemented: true,
        },
        // Future: { kind: "memberships", label: "Memberships", description: "...", implemented: false },
    ];

    export type Handler = {
        kind: Kind;
        run: (context: Context, options: BudgetOptions | undefined) => Promise<void>;
    };
}
